import React, { useState, useEffect } from 'react';
import styles from './LandingList.module.css';
import AxiosUrl from '../AxiosUrl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { AiOutlinePlus, AiOutlineEdit, AiOutlineDelete, AiOutlineEye, AiOutlineAppstore, AiOutlineUnorderedList, AiOutlineFileText } from 'react-icons/ai';

function LandingPageList() {
    const navigate = useNavigate();
    const uid = localStorage.getItem('id');
    const [landingPages, setLandingPages] = useState([]);
    const [open, setOpenModal] = useState(false);
    const [openCategory, setOpenCategoryModal] = useState(false);
    const [edit, setEdit] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState('list'); // Default is list view

    useEffect(() => {
        getLandingPages();
    }, [open, refresh, openCategory]);

    const getLandingPages = () => {
        setLoading(true);
        AxiosUrl.get(`/get-landing/${uid}`)
            .then((res) => {
                setLandingPages(res.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const deleteLandingPage = (did) => {
        const confirmDelete = window.confirm(
            'Are you sure you want to delete this landing page?'
        );
        if (confirmDelete) {
            setRefresh(false);
            AxiosUrl.post(`/delete-landing/${uid}`, { did })
                .then((res) => {
                    if (res.data.acknowledged) {
                        toast.success('Deleted successfully.');
                        setRefresh(true);
                    }
                })
                .catch(() => {
                    toast.error('Failed to delete the landing page.');
                });
        }
    };

    const viewLandingPage = (data) => {
        AxiosUrl.get(`/veiw-landing/${uid}`)
            .then((res) => {
                if (data.Landing == 1) {
                    window.open(`${res.data}/landing/${data._id}`, '_blank');
                } else {
                    window.open(`${res.data}/landing1/${data._id}`, '_blank');
                }
            })
            .catch((err) => {
                toast.error(err.response.data);
            });
    };

    return (
        <>
            <ToastContainer />
            <div className={styles.container}>
                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.headerLeft}>
                        <h1 className={styles.pageTitle}>Landing Pages</h1>
                        <p className={styles.pageSubtitle}>
                            Create and manage custom landing pages for your campaigns
                        </p>
                    </div>
                    <div className={styles.headerRight}>
                        <div className={styles.viewToggle}>
                            <button
                                className={viewMode === 'list' ? styles.viewButtonActive : styles.viewButton}
                                onClick={() => setViewMode('list')}
                                title="List view"
                            >
                                <AiOutlineUnorderedList size={18} />
                            </button>
                            <button
                                className={viewMode === 'grid' ? styles.viewButtonActive : styles.viewButton}
                                onClick={() => setViewMode('grid')}
                                title="Grid view"
                            >
                                <AiOutlineAppstore size={18} />
                            </button>
                        </div>
                        <button
                            className={styles.primaryButton}
                            onClick={() => navigate('/landing-page')}
                        >
                            <AiOutlinePlus size={18} />
                            <span>Create Landing Page</span>
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className={styles.contentCard}>
                    {loading ? (
                        <div className={styles.skeletonList}>
                            {[...Array(5)].map((_, i) => (
                                <div key={i} className={styles.skeletonListItem}>
                                    <div className={styles.skeleton} style={{width: '48px', height: '48px', borderRadius: '8px', flexShrink: 0}}></div>
                                    <div style={{flex: 1, minWidth: 0}}>
                                        <div className={styles.skeleton} style={{width: '60%', height: '15px', marginBottom: '6px'}}></div>
                                        <div className={styles.skeleton} style={{width: '35%', height: '13px'}}></div>
                                    </div>
                                    <div className={styles.skeleton} style={{width: '65px', height: '24px', borderRadius: '4px', flexShrink: 0}}></div>
                                    <div className={styles.skeletonListItemActions}>
                                        <div className={styles.skeleton} style={{width: '36px', height: '36px', borderRadius: '6px'}}></div>
                                        <div className={styles.skeleton} style={{width: '36px', height: '36px', borderRadius: '6px'}}></div>
                                        <div className={styles.skeleton} style={{width: '36px', height: '36px', borderRadius: '6px'}}></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : landingPages.length === 0 ? (
                        <div className={styles.emptyState}>
                            <AiOutlineFileText size={64} className={styles.emptyIcon} />
                            <h3>No landing pages yet</h3>
                            <p>Create your first landing page to start converting visitors</p>
                            <button
                                className={styles.primaryButton}
                                onClick={() => navigate('/landing-page')}
                            >
                                <AiOutlinePlus size={18} />
                                <span>Create Landing Page</span>
                            </button>
                        </div>
                    ) : viewMode === 'grid' ? (
                        <div className={styles.landingPagesGrid}>
                            {landingPages.map((data) => (
                                <div key={data._id} className={styles.landingCard}>
                                    <div className={styles.cardHeader}>
                                        <div className={styles.cardIcon}>
                                            <AiOutlineFileText size={24} />
                                        </div>
                                        <span className={styles.pageTypeBadge}>
                                            Page {data.Landing}
                                        </span>
                                    </div>
                                    <div className={styles.cardContent}>
                                        <h3 className={styles.cardTitle}>{data.Name}</h3>
                                        <div className={styles.cardMeta}>
                                            <span className={styles.metaLabel}>Template:</span>
                                            <span className={styles.metaValue}>Page {data.Landing}</span>
                                        </div>
                                    </div>
                                    <div className={styles.cardActions}>
                                        <button
                                            className={styles.viewButton}
                                            onClick={() => viewLandingPage(data)}
                                            title="View page"
                                        >
                                            <AiOutlineEye size={18} />
                                        </button>
                                        <button
                                            className={styles.editButton}
                                            onClick={() => {
                                                setEdit(data);
                                                setOpenModal(true);
                                                navigate(
                                                    data.Landing == 1
                                                        ? `/landing1/update/${data._id}`
                                                        : `/landing/update/${data._id}`,
                                                    {
                                                        state: data,
                                                    }
                                                );
                                            }}
                                            title="Edit page"
                                        >
                                            <AiOutlineEdit size={18} />
                                        </button>
                                        <button
                                            className={styles.deleteButton}
                                            onClick={() => deleteLandingPage(data._id)}
                                            title="Delete page"
                                        >
                                            <AiOutlineDelete size={18} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className={styles.landingPagesList}>
                            {landingPages.map((data) => (
                                <div key={data._id} className={styles.listItem}>
                                    <div className={styles.listItemIcon}>
                                        <AiOutlineFileText size={24} />
                                    </div>
                                    <div className={styles.listItemContent}>
                                        <h3 className={styles.listItemTitle}>{data.Name}</h3>
                                        <span className={styles.listItemMeta}>
                                            Template: Page {data.Landing}
                                        </span>
                                    </div>
                                    <div className={styles.listItemBadge}>
                                        <span className={styles.pageTypeBadge}>
                                            Page {data.Landing}
                                        </span>
                                    </div>
                                    <div className={styles.listItemActions}>
                                        <button
                                            className={styles.viewButton}
                                            onClick={() => viewLandingPage(data)}
                                            title="View page"
                                        >
                                            <AiOutlineEye size={18} />
                                        </button>
                                        <button
                                            className={styles.editButton}
                                            onClick={() => {
                                                setEdit(data);
                                                setOpenModal(true);
                                                navigate(
                                                    data.Landing == 1
                                                        ? `/landing1/update/${data._id}`
                                                        : `/landing/update/${data._id}`,
                                                    {
                                                        state: data,
                                                    }
                                                );
                                            }}
                                            title="Edit page"
                                        >
                                            <AiOutlineEdit size={18} />
                                        </button>
                                        <button
                                            className={styles.deleteButton}
                                            onClick={() => deleteLandingPage(data._id)}
                                            title="Delete page"
                                        >
                                            <AiOutlineDelete size={18} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default LandingPageList;
